

































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import MessageItem from "../messages/Item.vue";
import { MessageDto } from "@/store/messages/message.interface";
import Message from "@/store/messages";

interface UpdatedItemPayload {
  item: MessageDto;
  index: number;
}

@Component({
  components: {
    "message-item": MessageItem
  }
})
export default class AppMessageItem extends Vue {
  page: number = 1;
  data: MessageDto[] = [];
  query: string = "";
  @Prop() statusId: number;

  async infiniteHandler($state: any) {
    this.search($state);
  }

  async search($state: any) {
    try {
      const res = await Message.api().fetch({
        params: {
          page: this.page,
          keywords: this.query,
          status_id: this.statusId,
          order: "id||DESC"
        }
      });

      const messages = res.response.data.data;

      if (messages.length) {
        this.data.push(...messages);
        this.page += 1;
        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    } catch (error) {}
  }

  async onSearch(query: string) {
    this.page = 1;
    this.data = [];
    this.query = query;
    this.search(null);
  }

  async goTo(item: MessageDto) {
    this.$router.push("/messages/" + item.id);
  }

  mounted() {
    this.sockets.subscribe("messageAdded", (data: any) => {
      this.onSearch(this.query);
    });
  }

  destroyed() {
    this.sockets.unsubscribe("messageAdded");
  }

  onUpdatedItem(input: UpdatedItemPayload) {
    this.data = [
      ...this.data.slice(0, input.index),
      {
        ...(input.item as any)
      },
      ...this.data.slice(input.index + 1, this.data.length)
    ];
  }
}
